import { useState, useRef, useCallback } from "react";

export type SessionStatus = "Pending" | "Success" | "Failed" | "Stopped";

export function useStreamSession() {
  const [isStreaming, setIsStreaming] = useState(false);
  const isStreamingRef = useRef(false);

  const setIsStreamingWithRef = useCallback((val: boolean) => {
    isStreamingRef.current = val;
    setIsStreaming(val);
  }, []);

  const [sessionStatus, setSessionStatus] = useState<SessionStatus | undefined>(undefined);
  const [generationId, setGenerationId] = useState<string | null>(null);

  const isReconnectingRef = useRef(false);
  const activeReconnectionsRef = useRef<Set<string>>(new Set());
  const abortRef = useRef<AbortController | null>(null);

  const resetStream = useCallback(() => {
    abortRef.current?.abort();
    activeReconnectionsRef.current.clear();
    setIsStreamingWithRef(false);
    isReconnectingRef.current = false;
    setSessionStatus((prev) => (prev === "Pending" ? undefined : prev));
  }, [setIsStreamingWithRef]);

  return {
    isStreaming,
    isStreamingRef,
    setIsStreamingWithRef,
    sessionStatus,
    setSessionStatus,
    generationId,
    setGenerationId,
    isReconnectingRef,
    activeReconnectionsRef,
    abortRef,
    resetStream,
  };
}
